import React, {
    forwardRef,
    useMemo,
    useCallback,
} from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import { Tracking } from 'bdvp-tracking';

import { media } from '@mlb/react-patterns/style/helpers/media.ts';

import {
    SEARCH_ROUTE, QUERY_PARAMS, CarouselRowType
} from '../../../utils/constants';
import RowHeading from '../../RowHeading';
import { PersonalizedModuleV2 as PersonalizedModule } from '../../PersonalizedModule';

export const Wrapper = styled.div`
    ${({ theme }) => css`
        margin: 0 ${theme.pageTemplate.paddingLeftRight.xs} 20px;
        ${media.mdmin`
            margin: 0 ${theme.pageTemplate.paddingLeftRight.md} 20px;
        `};
        ${media.lgmin`
            margin: 0 ${theme.pageTemplate.paddingLeftRight.lg} 20px;
        `};
    `}
`;

const carouselType = CarouselRowType.PERSONALIZED_V2;

const PersonalizedRow = forwardRef((props, ref) => {

    const {
        title,
        categories,
        teamId,
        teamName,
        teamImageTemplateUrl,
        loading,
        rank,
    } = props;

    const teamLink = `${SEARCH_ROUTE}?${QUERY_PARAMS.query}=TeamId == [${teamId}] Order By Timestamp DESC`;
    const formattedCategories = useMemo(() => categories?.map(({
        title: category, iconName, query, queryClubFilter,
    }) => ({
        iconName,
        category,
        to: `${SEARCH_ROUTE}?${QUERY_PARAMS.query}=${queryClubFilter} == [${teamId}] AND ${query}`,
    })) ?? [], [
        categories,
        teamId,
    ]);

    const onItemClickHandler = useCallback(({
        id, index, type,
    }) => {

        Tracking.trackCarouselOnItemClick({
            carouselRank: rank,
            carouselTitle: title,
            index,
            id,
            carouselType,
            type,
        });

    }, [
        rank,
        title,
    ]);

    return (
        <Wrapper ref={ref}>
            <RowHeading text={title} loading={loading} />
            <PersonalizedModule
                loading={loading}
                teamId={teamId}
                teamName={teamName}
                teamImageTemplateUrl={teamImageTemplateUrl}
                teamLink={teamLink}
                categories={formattedCategories}
                onItemClick={onItemClickHandler}
            />
        </Wrapper>
    );

});

PersonalizedRow.propTypes = {
    rank: PropTypes.number.isRequired,
    title: PropTypes.string,
    teamId: PropTypes.number,
    teamName: PropTypes.string,
    teamImageTemplateUrl: PropTypes.string,
    categories: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string.isRequired,
            query: PropTypes.string.isRequired,
            queryClubFilter: PropTypes.string.isRequired,
            iconName: PropTypes.string.isRequired,
        })
    ),
    loading: PropTypes.bool,
};

export default PersonalizedRow;
